import styled from "styled-components";

import Hot from '@/static/images/hot.png'
import Gift from '@/static/images/gift.png'

export const layoutWidth = 1200

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1200px;
  /* max-width: calc(100vw - 60px); */
  margin: 0 auto;
  height: 75px;
  padding: 0 30px;
  background-color: #fff;
  box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.1);
  border-radius: 15px;
  box-sizing: border-box;
  /* position: sticky; */
  /* top: 10px; */
  position: fixed;
  top: 0;
  transform: translateY(30px);
  left: 50%;
  margin-left: -600px;
  z-index: 99;
  transition: all .3s ease-out 0s;

  &.black-header {
    background-color: transparent;

    &.hideTop {
      background-color: rgba(0,0,0,0.85);
    }

    &.top10 {
      background-color: #000;
      opacity: 0.85;
    }

    & > .button {
      background-color: #000;
      box-sizing: border-box;
      border: 1px solid #fff;
    }

    &.sub-mobile {
      .setting {
        div {
          span {
            background-color: #fff;
          }

          &::before, &::after {
            background-color: #fff;
          }
        }
      }
      .close {
        div {
          span {
            background-color: #333;
          }

          &::before, &::after {
            background-color: #333;
          }
        }
      }
    }
  }

  &.sub-mobile {
    width: auto;
    height: 52px;
    padding: 0 15px;
    margin: 0;
    left: 12px;
    top: 12px;
    right: 10px;
    transform: none!important;
    transition: none;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
    border-radius: 10px;
    opacity: 1!important;

    & > .button {
      display: none;
    }

    .setting {
      height: 52px;
      padding: 0 15px;
      display: flex;
      align-items: center;
      position: relative;
      right: -15px;
      z-index: 10;

      div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
        width: 18px;
        height: 14px;
        cursor: pointer;

        span {
          width: 100%;
          height: 2px;
          background-color: #333;
          /* transition: opacity .3s ease-out 0s; */
          border-radius: 2px;
        }

        &::before, &::after {
          content: "";
          width: 100%;
          height: 2px;
          background-color: #333;
          border-radius: 2px;
          transition: transform .3s ease-in-out 0s;
          transform: rotate(0deg);
          transform-origin: right top;
        }

        &::after {
          transform-origin: right bottom;
        }
      }
      
    }

    .close {
      span {
        /* opacity: 0; */
        display: none;
      }

      div {
        &::before {
          transform: rotate(-45deg);
        }

        &::after {
          transform: rotate(45deg);
        }
      }
    }
  }

  & > a:first-child {
    position: relative;
    z-index: 1;

    & > svg {
      display: block;
    }
  }

  &.top10 {
    /* transform: translateY(10px); */
    opacity: 0.75;

    &:hover {
      opacity: 1;
    }
  }

  &.hideTop {
    transform: translateY(-120%);
  }

  & > .buy-dmail {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 140px;
    height: 40px;
    padding: 0;
    line-height: 40px;
    font-size: 14px;
    border-radius: 10px;
    color: #E9361B;
    white-space: nowrap;

    svg {
      margin-right: 10px;
    }
  }

  & > a {
    cursor: pointer;
  }
`

export const Nav = styled.div`
  display: flex;
  align-items: center;
  height: 35px;

  &.black-header-nav {
    color: #fff;

    &.sub-mobile {
      color: #333;


    }

    & > div {
      &.split {
        &::before {
          background-color: #747474;
        }
      }

      &.more {
        &:hover {
          color: #c0c0c0;
        }
      }
    }

    ul {
      li {
        color: #333;
      }
    }
  }

  &.sub-mobile {
    flex-direction: column;
    height: 100%;
    position: fixed;
    top: 0px;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 84px 27px 30px;
    background: rgb(255, 255, 255, 0.98);
    overflow-y: auto;
    display: none;
    opacity: 0;
    transition: all 0.4s ease-out 0.1s;
    box-sizing: border-box;

    @keyframes show-nav {
      0% {
        opacity: 0;
        /* transform: translateY(60px); */
      }
      100% {
        opacity: 1;
        /* transform: translateY(72px); */
      }
    }

    &.show {
      display: block;
      animation: show-nav 0.4s ease-out 0s 1;
      animation-fill-mode: forwards;
    }

    & > div {
      height: auto;
      border: none;
      margin: 0;
      padding: 15px 0;
      line-height: 1;
      font-size: 16px;
      text-align: left;

      &:not(:last-child) {
        margin: 0 0 5px 0;
      }

      &.split {
        padding-right: 0;
        padding-bottom: 30px;
        border-bottom: 1px solid #e8e8e8;

        &::before {
          display: none;
        }
      }

      &.has-icon {
        i {
          order: 2;
          margin-left: 10px;
          transform: scale(1.2);
        }
      }

      &.more {
        /* background: #F5F5F5; */
        /* border-radius: 10px 10px 10px 10px; */

        &::after {
          transform: rotate(90deg)!important;
        }
      }

      ul {
        display: block;
        transform: none;
        min-width: 0;
        background: none;
        box-shadow: none;
        padding: 0;
        margin: 0;
        left: 0;
        bottom: 0;
        top: auto;

        li {
          justify-content: start;
          padding: 0 0 0 15px;
          background-color: transparent!important;
          color: #333;

          &.on {
            color: #BF2E20;
          }
        }

        &::before, &::after {
          display: none;
        }
      }
    }
  }

  & > div, & li {
    i {
      width: 14px;
      height: 15px;
      margin-right: 5px;
      background-size: 100%;

      &.hot {
        background-image: url(${Hot});
      }
      &.gift {
        background-image: url(${Gift});
      }
    }
  }

  & > div {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    height: 100%;
    font-family: Inter-Medium;
    font-size: 14px;

    span {
      /* transition: text-shadow .3s ease-out 0s; */
    }

    /* &:hover {
      & > span {
        text-shadow: 3px 10px 12px rgba(0, 0, 0, .7);
      }
    } */

    &:not(:last-child) {
      margin-right: 40px;
    }

    &.on, &:hover {
      color: #BF2E20;
    }

    &.empty, &.more {
      cursor: default;

      &:hover {
        color: #333;
      }
    }

    &.more {
      &:hover {
        svg {
          transform: rotate(-180deg);
        }
      }

      svg {
        margin-left: 6px;
        transform-origin: center;
        transition: transform .3s ease 0s;
        position: relative;
        top: 1px;
      }
    }

    &.split {
      padding-right: 46px;

      &::before {
        content: '';
        width: 1px;
        height: 100%;
        position: absolute;
        left: 100%;
        top: 0;
        height: 100%;
        background-color: #eee;
      }
    }

    &:hover {
      ul {
        display: block;
      }
    }

    &.split {
      ul {
        margin-left: -23px;
      }
    }

    ul {
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      min-width: 150px;
      background-color: #fff;
      border-radius: 5px;
      box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 20px 0px;
      padding: 12px 0;
      margin-top: 10px;
      font-weight: normal;
      display: none;

      li {
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 36px;
        padding: 0 15px;
        font-size: 14px;
        white-space: nowrap;
        cursor: pointer;

        &.on, &:hover {
          background-color: #eee;
        }
      }

      &::before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 100%;
        width: 100%;
        height: 10px;
      }

      &::after {
        content: '';
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border: 10px dashed transparent;
        border-bottom: 10px solid #fff; 
      }
    }
  }
`

export const Contact = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 100px;

  &.sub-mobile {
    flex-direction: column;
    margin-top: 40px;

    .left {
      width: auto;
      margin-bottom: 40px;

      svg {
        transform: scale(0.8);
        transform-origin: left center;
      }

      p {
        line-height: 16px;
        font-size: 12px;

        &:first-of-type {
          margin: 15px 0 20px;
        }
      }
    }

    .right {
      justify-content: space-between;
      line-height: 16px;

      dl {
        margin: 0;

        &:first-child {
          dt, dd {
            transform-origin: left center;
          }
        }

        &:last-child {
          dt, dd {
            transform-origin: right center;
          }
        }
      }

      dt {
        margin-bottom: 8px;
        font-size: 12px;
      }

      dd {
        margin-top: 8px;

        a {
          font-size: 12px;
          line-height: 16px;
        }
      }

      dt, dd {
        transform: scale(0.85);
      }
    }
  }

  .left {
    width: 412px;

    img {
      display: block;
    }
    
    p {
      color: #666666;
      line-height: 20px;
      font-size: 14px;

      &:first-of-type {
        margin: 35px 0 12px;
      }
    }
  }

  .right {
    display: flex;
    line-height: 20px;

    dl {
      margin-left: 45px;
    }

    dt {
      margin-bottom: 35px;
      color: #000;
      font-weight: bold;
      font-size: 16px;
    }

    dd {
      margin-top: 25px;

      a {
        font-size: 16px;
        color: #666;
        line-height: 20px;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
          color: #111;
        }
      }
    }
  }
`

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 40px;
  border-top: 1px solid #eee;
  padding-top: 30px;

  &.mobile {
    margin-top: 20px;
    padding-top: 15px;
    overflow: hidden;

    .links {
      strong {
        margin-right: 20px;
        font-size: 12px;
      }

      a {
        transform: scale(0.76);
        margin-right: 10px;
      }
    }

    .ltd {
      font-size: 12px;
      transform: scale(0.8) translateX(-20px);
      white-space: nowrap;
      transform-origin: right center;
    }
  }

  .links {
    display: flex;
    align-items: center;

    strong {
      margin-right: 40px;
      font-size: 16px;
      color: #666;
    }

    a {
      margin-right: 20px;
    }
  }

  .ltd {
    font-size: 15px;
    color: #999;
  }
`

export const Subscribe = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #333;
  padding: 45px 100px;
  border-radius: 10px;

  &.sub {
    padding: 45px 120px;

    .pic {
      margin-right: 150px;
    }
  }

  &.mobile {
    padding: 25px 15px;
    flex-direction: column;

    .pic {
      margin: 0;
    }

    h2 {
      font-size: 22px;

      span {
        padding-left: 6px;
      }
    }

    p {
      margin: 10px 0 20px;
      font-size: 12px;
    }
  }

  .pic {
    margin-right: 100px;
  }

  .detail {
    flex: 1;
  }

  h2 {
    font-size: 42px;
    color: #fff;

    span {
      padding-left: 15px;
      color: #C02C16;
      background-image: linear-gradient(to bottom, #E9361B, #C02C16);
      color: #fff;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  p {
    margin: 20px 0 35px;
    color: #ccc;
    font-size: 16px;
  }

  .to-sub {
    svg {
      margin-left: 5px;
    }

    &:hover {
      box-shadow: 1px 2px 9px 0px rgba(255, 86, 63, 0.5);
    }
  }

`